import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../services';
import { MessageBoxType, ToastService } from '../modules/toast';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private session: SessionService,
    private toast: ToastService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        //handle toast shows or not
        const skipToast = !!req.headers.get('skipToast');
        if ([401, 403, 500].includes(error.status)) {
          const message = error.message;
          this.toast.show(
            error.statusText + ' - ' + error?.error?.statusMessage,
            message,
            MessageBoxType.DANGER,
            10000
          );
          if (message == 'Invalid token') {
            this.logoutCallback();
          } else {
            this.handlerError(error.status, error);
          }
        } else if (error.url === 'https://localhost:8443/SGIFPCapture') {
          this.toast.show('Bio Error', error.message, MessageBoxType.DANGER);
        } else {
          if (this.badRequestExceptionHandler()) return throwError(error);
          // Handle non 401, 500 errors
          if (error?.error?.statusMessage && !skipToast) {
            const msg = error.statusText + '  ' + error.message + '  ' + error?.error?.statusMessage;
            this.toast.show('', msg, MessageBoxType.DANGER);
          } else if (error?.error?.responseObject && !skipToast) {
            const msg =
              error.statusText +
              '  ' +
              error?.error?.responseObject +
              '  ' +
              error.message +
              '  ' +
              error?.error?.statusMessage;
            this.toast.show('', msg, MessageBoxType.DANGER);
          } else if (!error?.error?.statusMessage && !error?.error?.responseObject && !skipToast) {
            const msg = error.statusText + '  ' + error.message + '  ' + error?.error?.statusMessage;
            this.toast.show('', msg, MessageBoxType.DANGER);
          } else if ((error?.error?.statusDescription || error.error?.error_description) && !skipToast) {
            const msg = error?.error?.statusDescription || error.error?.error_description + '---' + error.message;
            this.toast.show(error.statusText, msg, MessageBoxType.DANGER);
          } else if (error.message && !skipToast) {
            const msg = error.message;
            this.toast.show(error.statusText, msg, MessageBoxType.DANGER);
          } else if (!skipToast) {
            this.toast.show(error.statusText, this.getErrorMessage(error), MessageBoxType.DANGER);
          }
          const err = error?.error?.message || error?.statusText;
        }
        return throwError(() => error);
      })
    );
  }

  badRequestExceptionHandler() {
    return false;
  }

  getErrorMessage = (error: HttpErrorResponse) => {
    try {
      return (
        error.statusText +
        '-' +
        error.error.responseObject[0].errors[0] +
        '-' +
        error.error.statusMessage +
        '-' +
        error.message
      );
    } catch (e) {
      return error?.status + error.error.responseObject[0].errors[0] + error.message;
    } finally {
      /*eslint no-unsafe-finally: 0*/
      return 'ERRORS.UNKNOWN-ERROR';
    }
  };

  private handlerError(errorNumber: number, error?: any) {
    let title!: any;
    let message!: any;
    let btnName!: any;
    switch (errorNumber) {
      case 401:
        btnName = 'LOGIN.COMMON.SIGN-IN';
        title = 'LOGIN.COMMON.UNAUTHORIZED';
        message = 'LOGIN.COMMON.REQUEST-UNAUTHORIZED';
        this.toast.show(title, message, MessageBoxType.DANGER, 200000, btnName, this.logoutCallback);
        break;
      case 403:
        btnName = 'LOGIN.COMMON.SIGN-IN';
        title = 'LOGIN.COMMON.FORBIDDEN';
        message = 'LOGIN.COMMON.REQUEST-FORBIDDEN';
        this.toast.show(title, message, MessageBoxType.DANGER, 10000);
        break;
      case 500:
        title = 'ERRORS.SERVER-ERROR';
        message = 'ERRORS.SERVER-ERROR-TEXT';
        if (error?.error?.statusMessage && !error?.error?.responseObject) {
          const msg = error.statusText + '---' + error.message;
          this.toast.show(error?.error?.statusMessage, msg, MessageBoxType.DANGER);
        }
        break;
      default:
        break;
    }
  }

  logoutCallback = () => {
    const location = window.location;
    this.session.setUrlParameter(this.router.routerState.snapshot.url);
    if (!this.session.isLoggedIn()) return location.reload();
    this.session.logout().subscribe(() => this.session.login(null, '1'));
  };
}
